import { Directive, ElementRef ,Input } from '@angular/core';

@Directive({
//  selector: '[appTheme]'
  selector: '[theme]'
})
export class ThemeDirective {

  @Input('styleObj')
    set styleObj(value: any){
    if(value) {
      this.updateTheme(value);
    }
  }

  constructor(
    private _elementRef: ElementRef
  ) { }

  updateTheme(properties: any) {
    // project properties onto the element
    for (const key in properties) {
      this._elementRef.nativeElement.style.setProperty(key, properties[key]);
    }
  }
}
